import { createContext, useContext, useState, ReactNode, useCallback } from 'react';
import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import { UpdateAccountForm } from '@/containers/update-account-form';
import { getIsMobile } from '@/utils/get-is-mobile';

interface UpdateAccountDialogContextValue {
  openUpdateAccountDialog: () => void;
  closeUpdateAccountDialog: () => void;
}

const UpdateAccountDialogContext = createContext<UpdateAccountDialogContextValue | null>(null);

export const UpdateAccountDialogProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);

  const openUpdateAccountDialog = useCallback(() => setOpen(true), []);
  const closeUpdateAccountDialog = useCallback(() => setOpen(false), []);

  const isMobile = getIsMobile();

  return (
    <UpdateAccountDialogContext.Provider
      value={{ openUpdateAccountDialog, closeUpdateAccountDialog }}
    >
      {children}
      <Dialog open={open && !isMobile}>
        <DialogContent className="p-10 max-md:w-[360px] max-md:p-8" noCloseBtn>
          <UpdateAccountForm onCompleted={closeUpdateAccountDialog} />
        </DialogContent>
      </Dialog>
    </UpdateAccountDialogContext.Provider>
  );
};

export const useUpdateAccountDialog = () => {
  const context = useContext(UpdateAccountDialogContext);
  if (!context) {
    throw new Error('useUpdateAccountDialog must be used within UpdateAccountDialogProvider');
  }
  return context;
};
